'use client';

import { useSetAtom } from 'jotai';
import { SyntheticEvent } from 'react';
import classNames from 'classnames';
import styles from './Company.module.scss';
import contactModalTriggerButton from '../../store/contactForm';
import { GAEmit, GAEvents } from '../../gtagHelper';

const LetsCollaborateButton = () => {
  const setContactsModalTrigger = useSetAtom(contactModalTriggerButton);

  const handleLetsCollaborate = (event: SyntheticEvent) => {
    setContactsModalTrigger(`${(event.target as HTMLElement).innerText} | Company page hero button`);
    GAEmit(GAEvents.letsCollaborateClick);
  };

  return (
    <button
      type='button'
      className={classNames(styles.tile, styles.startProjectButton)}
      onClick={handleLetsCollaborate}
    >
      <div
        className={classNames(styles.icon)}
      >
        <svg>
          <use
            xlinkHref='/media/icon-nest.svg#iconNest'
            href='/media/icon-nest.svg#iconNest'
          />
        </svg>
      </div>
      <p className={styles.startProjectButton__title}>Let`s Collaborate!</p>
    </button>
  );
};

export default LetsCollaborateButton;
